import { FC } from "react";
import { Box, Chip, Stack, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";

import { ProjectCard } from "src/components/organism/ProjectCard";
import { projects } from "src/components/organism/constant";

const Portfolio: FC = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={4} py={{ xs: 3, md: 5 }}>
      <SectionHeader title={t("portfolio")} eyebrow="Selected work" />

      <Stack spacing={1}>
        <Typography level="title-lg">{t("myLastProjects")}</Typography>
        <Typography level="body-md" sx={{ color: "text.tertiary" }}>
          A quick look at recent projects and product experiences.
        </Typography>
      </Stack>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr" },
          gap: 3,
        }}
      >
        {projects.map(({ image, title, link }, index) => (
          <ProjectCard key={`${title}-${index}`} image={image} title={title} link={link} />
        ))}
      </Box>
    </Stack>
  );
};

const SectionHeader = ({ title, eyebrow }: { title: string; eyebrow: string }) => {
  return (
    <Stack spacing={1}>
      <Chip color="primary" variant="soft" sx={{ width: "fit-content", borderRadius: 999 }}>
        {eyebrow}
      </Chip>
      <Typography level="h2">{title}</Typography>
      <Stack spacing={0.6}>
        <Box sx={{ height: 5, width: 88, borderRadius: 999, bgcolor: "primary.500" }} />
        <Box sx={{ height: 5, width: 52, borderRadius: 999, bgcolor: "primary.300" }} />
      </Stack>
    </Stack>
  );
};

export default Portfolio;
